import script from "./PayLoadding.vue?vue&type=script&setup=true&lang=js"
export * from "./PayLoadding.vue?vue&type=script&setup=true&lang=js"

import "./PayLoadding.vue?vue&type=style&index=0&id=d556361c&scoped=true&lang=less"

import exportComponent from "E:\\code\\软著项目\\agent\\software-agent\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d556361c"]])

export default __exports__